'use client';

import { useTranslation } from 'next-i18next';

import { Map } from '@/src/shared/presentation/components/map';

import { CMSBlockTitle } from '../cms-block-title';
import { CMSBlockWrapper } from '../cms-block-wrapper';

import css from './how-to-arrive-block-view.css';

import type { HowToArriveBlockViewModel } from '../../view-models/blocks/how-to-arrive-block.viewModel';

export function HowToArriveBlockView({
  hide,
  title,
  address,
  bus,
  subway,
  airport,
  latitude,
  longitude
}: HowToArriveBlockViewModel) {
  const { t } = useTranslation('cms', { keyPrefix: 'components.how_to_arrive_block' });
  const mapCenter = latitude && longitude ? { latitude, longitude } : undefined;

  return hide ? null : (
    <CMSBlockWrapper contentClassName={css.content}>
      <div className={css.header}>
        <CMSBlockTitle value={title} />
        <p className={css.address}>{address}</p>
      </div>

      <div className={css.main}>
        <div className={css.mapWrapper}>
          <Map className={css.map} center={mapCenter} zoom={15} />
        </div>

        <div className={css.infoWrapper}>
          {bus ? (
            <div className={css.infoItem}>
              <span className={css.infoItemTitle}>{t('bus')}</span>
              <p className={css.infoItemBody}>{bus}</p>
            </div>
          ) : null}

          {subway ? (
            <div className={css.infoItem}>
              <span className={css.infoItemTitle}>{t('subway')}</span>
              <p className={css.infoItemBody}>{subway}</p>
            </div>
          ) : null}

          {airport ? (
            <div className={css.infoItem}>
              <span className={css.infoItemTitle}>{t('airport')}</span>
              <p className={css.infoItemBody}>{airport}</p>
            </div>
          ) : null}
        </div>
      </div>
    </CMSBlockWrapper>
  );
}
